"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Card-MeetingAlert.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Image_template = require("../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    marko_attrs0 = {
        "class": "card library-card item cyan darken-1"
      },
    marko_attrs1 = {
        "class": "card-content"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("4d1d00"),
    marko_node0 = marko_createElement("div", {
        "class": "card-body"
      }, "2", null, 3, 0, {
        i: marko_const_nextId()
      })
      .e("h4", {
          "class": "card-title"
        }, null, null, 1)
        .t("You have an upcoming live session!")
      .e("br", null, null, null, 0)
      .e("div", {
          "class": "row"
        }, null, null, 2)
        .e("div", {
            "class": "col-4 card-x-icon"
          }, null, null, 1)
          .e("i", {
              "class": "bx bxs-slideshow"
            }, null, null, 0)
        .e("div", {
            "class": "col"
          }, null, null, 2)
          .e("p", {
              "class": "card-text"
            }, null, null, 1)
            .t("Emotional Intelligence Conversation")
          .e("small", null, null, null, 1)
            .t("11:00pm - 1:30am"),
    marko_attrs2 = {
        "class": "card-bottom only-dark-bg-fade d-flex align-items-center"
      },
    marko_node1 = marko_createElement("div", null, "13", null, 3, 0, {
        i: marko_const_nextId()
      })
      .e("span", null, null, null, 1)
        .t("Eleanor Sandiogo")
      .e("br", null, null, null, 0)
      .e("small", {
          "class": "d-block text-muted"
        }, null, null, 1)
        .t("Communication");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.be("div", marko_attrs1, "1", component);

  out.n(marko_node0, component);

  out.be("div", marko_attrs2, "11", component);

  Image_tag({
      alt: "avatar",
      src: "/images/Hello-vino-1619433782326.jpg",
      class: "rounded-circle mr-4",
      style: "width:35px;height:35px"
    }, out, __component, "12");

  out.n(marko_node1, component);

  out.ee();

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
